import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
    selector: 'app-card-grid',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: `
        @use "variables" as *;
        @use "functions" as *;

        :host {
            &.list-view {
                display: flex;
                flex-direction: column;
            }

            &:not(.list-view) {
                display: grid;
                grid-template-columns: repeat(var(--max-cards), 1fr);
                grid-gap: 20px;

                @include break(1200px) {
                    grid-gap: 15px;
                }

                @include break(1024px) {
                    grid-template-columns: repeat(3, 1fr);
                    grid-gap: 20px;
                }
                @include break(996px) {
                    grid-template-columns: repeat(2, 1fr);
                }
                @include break(650px) {
                    grid-template-columns: repeat(1, 1fr);
                }
            }
        }
    `,
    template: `
        <ng-content/>`,
})
export class CardGridComponent {
    public listView = input.required({ transform: booleanAttribute });
    public maxCards = input(4);

    @HostBinding('class.list-view') get view() {
        return this.listView();
    }

    @HostBinding('style.--max-cards')
    get cssMaxColumns(): string {
        return this.maxCards().toString();
    }
}
